$.fx.off = document.documentElement.dataset.ci === 'true';
